import { Box } from '@bpba/ui-components';
import { LayoutProps } from '../../types/LayoutProps';

export const ContainerMain = (props: LayoutProps) => {
  return (
    <Box paddingX={['16px', '0px']} flexDirection="column">
      {props.children}
    </Box>
  );
};
